const ttl = process.env.VUE_APP_CONTENT_CACHE_TTL

export default {
  methods: {
    resourceStale(date) {
      return !date && Date.now() - date > ttl
    }
  }
}
